import React from "react";

import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import BASESvgIcon from "../../../../../../../@BASE/core/BASESvgIcon";
import Instructions from "../components/Instructions";
import { ImageAttribution } from "../components/ImageAttribution";

export default function PECapstonePresentationBrief(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>

      <Instructions
        ins={ins}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
      />

      <Typography className="text-16 font-bold p-16 pb-0">
        Page Content:
      </Typography>

      <Paper elevation={0} variant="outlined" square className="p-16 m-16">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Title Slide:
                </Typography>
                <Divider className="my-16" />
              </Grid>
              <Grid item xs={12} sm={4} lg={2}>
                <Typography className="text-14 m-0">
                  Powerpoint Title (TL):
                </Typography>
              </Grid>
              <Grid item xs={12} sm={8} lg={10}>
                <Typography className={`${tl} m-0 font-semibold`} dir={dir}>
                  {data.ppt_title}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ImageAttribution attribution={data.media} tl={tl} dir={dir} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0} variant="outlined" square className="p-16 m-16">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Second Slide:
                </Typography>
                <Divider className="my-16" />
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12} sm={4} lg={2}>
                    <Typography className="text-14 font-semibold m-0">
                      Prompt (TL):
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={8} lg={10}>
                    <Typography
                      className={`${tl} m-0 wysiwyg`}
                      dir={dir}
                      dangerouslySetInnerHTML={{ __html: data.prompt_tl }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} lg={2}>
                    <Typography className="text-14 font-semibold m-0">
                      Prompt (EN):
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={8} lg={10}>
                    <Typography
                      className="text-14 m-0 wysiwyg"
                      dangerouslySetInnerHTML={{ __html: data.prompt_en }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0} variant="outlined" square className="p-16 m-16">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Third Slide:
                </Typography>
                <Divider className="my-16" />
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12} sm={4} lg={2}>
                    <Typography className="text-14 font-semibold m-0">
                      Key Points (TL):
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={8} lg={10}>
                    <Typography
                      className={`${tl} m-0 wysiwyg`}
                      dir={dir}
                      dangerouslySetInnerHTML={{ __html: data.key_points_tl }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} lg={2}>
                    <Typography className="text-14 font-semibold m-0">
                      Key Points (EN):
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={8} lg={10}>
                    <Typography
                      className="text-14 m-0 wysiwyg"
                      dangerouslySetInnerHTML={{ __html: data.key_points_en }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0} variant="outlined" square className="p-16 m-16">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Fourth Slide:
                </Typography>
                <Divider className="my-16" />
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12} sm={4} lg={2}>
                    <Typography className="text-14 font-semibold m-0">
                      Schoolhouse Answer Instruction (TL):
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={8} lg={10}>
                    <Typography
                      className={`${tl} m-0 wysiwyg`}
                      dir={dir}
                      dangerouslySetInnerHTML={{ __html: data.sa_ins_tl }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} lg={2}>
                    <Typography className="text-14 font-semibold m-0">
                      Schoolhouse Answer Instruction (EN):
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={8} lg={10}>
                    <Typography
                      className="text-14 m-0 wysiwyg"
                      dangerouslySetInnerHTML={{ __html: data.sa_ins_en }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} lg={2}>
                    <Typography className="text-14 font-semibold m-0">
                      Feedback Response:
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={8} lg={10}>
                    <Typography
                      className={`${tl} m-0 wysiwyg`}
                      dir={dir}
                      dangerouslySetInnerHTML={{ __html: data.response }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
}
